import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import {
  BI_UPSELL_CONTACT_LOCALSTORAGE_KEY,
  MI_UPSELL_CONTACT_LOCALSTORAGE_KEY,
} from 'lumen/utils/constants/general-constants';
import {
  TRIAL_INDICATION_LOCALSTORAGE,
  TRIAL_INDICATION_LOCALSTORAGE_EXPIRED_AUTO_OPEN,
  TRIAL_INDICATION_LOCALSTORAGE_KEY,
  TRIAL_INDICATION_LOCALSTORAGE_NEARLY_EXPIRED_AUTO_OPEN,
} from 'lumen/utils/constants/trial-indication-constants';

export default class SpiderPortfolioController extends Controller {
  @service declare ajax: Services['ajax'];
  @service declare intl: Services['intl'];
  @service declare localStorage: Services['local-storage'];

  @tracked active = false;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iframeQPs() {
    return { iframe: 1, origin: window.location.origin };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get settingsOptions() {
    const res = [
      {
        label: this.intl.t('menu.logout'),
        action: 'logout',
        icon: 'logout' as IconName,
      },
    ];

    return res;
  }

  @action logout(): void {
    this.localStorage.removeItem('ajs_user_traits');
    this.localStorage.removeItem(TRIAL_INDICATION_LOCALSTORAGE);
    this.localStorage.removeItem(TRIAL_INDICATION_LOCALSTORAGE_KEY);
    this.localStorage.removeItem(
      TRIAL_INDICATION_LOCALSTORAGE_NEARLY_EXPIRED_AUTO_OPEN,
    );
    this.localStorage.removeItem(
      TRIAL_INDICATION_LOCALSTORAGE_EXPIRED_AUTO_OPEN,
    );
    this.localStorage.removeItem(BI_UPSELL_CONTACT_LOCALSTORAGE_KEY);
    this.localStorage.removeItem(MI_UPSELL_CONTACT_LOCALSTORAGE_KEY);
    this.ajax
      .post('/logout/')
      .then(() => {
        window.location.href = '/login';
      })
      .catch(() => {
        window.location.href = '/login';
      });
  }

  @action onSettingsDropdownChange(
    option: (typeof this.settingsOptions)[number],
  ): void {
    this.send(option.action);
  }

  @action toggleActive(): void {
    this.active = !this.active;
  }
}
